var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBiometricDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L9.18198 8.12132L11.8336 5.46967C12.1265 5.17678 12.6014 5.17678 12.8943 5.46967C13.1872 5.76256 13.1872 6.23744 12.8943 6.53033L10.2426 9.18198L12.8943 11.8336C13.1872 12.1265 13.1872 12.6014 12.8943 12.8943C12.6014 13.1872 12.1265 13.1872 11.8336 12.8943L9.18198 10.2426L6.53033 12.8943C6.23744 13.1872 5.76257 13.1872 5.46967 12.8943C5.17678 12.6014 5.17678 12.1265 5.46967 11.8336L8.12132 9.18198L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z",
    fill: "#F31919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBiometricDelete);
export default __webpack_public_path__ + "static/media/ic_biometric_delete.607662474831936aa6c690c0fded0486.svg";
export { ForwardRef as ReactComponent };